<template>
    <tr>
        <td class="sticky-col">
            <div style="margin-left: 20px">
                {{ docname }}
            </div>
        </td>
        <template v-if="showOnlyPlanned">
            <td>
                <template v-if="data['executed_on_date'] !== undefined && data['executed_on_date']['total']">
                    <span style="cursor: pointer; text-decoration: underline;"
                          @click="seeInstallations('executed_on_date',classification, data['executed_on_date']['installations'])">
                        {{ data['executed_on_date']['total'] }}
                    </span>
                </template>
                <template v-else>
                    0
                </template>
            </td>
            <td> {{ data['percentage_executed_on_date'] }}%</td>
            <td>
                <div v-if="data['executed_out_of_date'] !== undefined && data['executed_out_of_date']['total'] !== ''">
                    <template v-if="data['executed_out_of_date']['total']">
                        <span style="cursor: pointer; text-decoration: underline;"
                              @click="seeInstallations('executed_out_of_date', classification, data['executed_out_of_date']['installations'])">
                            {{ data['executed_out_of_date']['total'] }}
                        </span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </div>
            </td>
            <td> {{ data['percentage_executed_out_of_date'] }}%</td>
            <td class="ejecutado-totales">
                <template v-if="data['executed_out_of_date'] !== undefined && data['executed_on_date'] !== undefined">
                    <span style="cursor: pointer; text-decoration: underline;"
                          @click="seeInstallations('executed_out_of_date', classification, combineInstallationsObjects(data['executed_on_date']['installations'], data['executed_out_of_date']['installations']))">
                        {{ data['executed_on_date']['total'] + data['executed_out_of_date']['total'] }}
                    </span>
                </template>
            </td>
            <td class="ejecutado-totales"> {{ data['percentage_total_executed'] }}%</td>
        </template>
        <template v-if="showPlanned">
            <td>
                <template v-if="data['planned'] !== undefined && data['planned']['total']">
                    <span style="cursor: pointer; text-decoration: underline;"
                          @click="seeInstallations('planned', classification, data['planned']['installations'])">
                        {{ data['planned']['total'] }}
                    </span>
                </template>
                <template v-else>
                    0
                </template>
            </td>
            <td> {{ data['percentage_planned'] }}%</td>
            <td>
                <template v-if="data['planned_less_3_months'] !== undefined && data['planned_less_3_months']['total']">
                    <span style="cursor: pointer; text-decoration: underline;"
                          @click="seeInstallations('planned_less_3_months', classification, data['planned_less_3_months']['installations'])">
                        {{ data['planned_less_3_months']['total'] }}
                    </span>
                </template>
                <template v-else>
                    0
                </template>
            </td>
            <td> {{ data['percentage_planned_less_3_months'] }}%</td>
            <td class="en-curso-totales">
                <template>
                    <span style="cursor: pointer; text-decoration: underline;"
                          @click="seeInstallations('planned', classification, ({ ...data['planned']['installations'] }))">
                        {{ data['planned']['total'] }}
                    </span>
                </template>
            </td>
            <td class="en-curso-totales">
                {{ data['percentage_total_planned'] }}%
            </td>
        </template>
        <template v-if="showOnlyPlanned">
            <td>
                <div>
                    <template v-if="data['not_executed_less_3_months'] !== undefined && data['not_executed_less_3_months']['total'] !== ''">
                        <span style="cursor: pointer; text-decoration: underline;"
                              @click="seeInstallations('not_executed_less_3_months', classification, data['not_executed_less_3_months']['installations'])">
                            {{ data['not_executed_less_3_months']['total'] }}
                        </span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </div>
            </td>
            <td>{{ data['percentage_out_of_date_less_3_months'] }}%</td>
            <td>
                <div>
                    <template v-if="data['not_executed_more_3_months'] !== undefined">
                        <span style="cursor: pointer; text-decoration: underline;"
                              @click="seeInstallations('not_executed_more_3_months', classification, data['not_executed_more_3_months']['installations'])">
                            {{ data['not_executed_more_3_months']['total'] }}
                        </span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </div>
            </td>
            <td>{{ data['percentage_out_of_date_more_3_months'] }}%</td>
            <td class="vencido-totales">
                <div>
                    <template v-if="data['not_executed_less_3_months'] !== undefined && data['not_executed_more_3_months'] !== undefined">
                        <span style="cursor: pointer; text-decoration: underline;"
                              @click="seeInstallations('not_executed_less_3_months', classification, combineInstallationsObjects(data['not_executed_less_3_months']['installations'], data['not_executed_more_3_months']['installations']))">
                            {{ data['not_executed_less_3_months']['total'] + data['not_executed_more_3_months']['total'] }}
                        </span>
                    </template>
                    <template v-else>
                        0
                    </template>
                </div>
            </td>
            <td class="vencido-totales">
                {{ data['percentage_total_not_executed'] }}%
            </td>
            <td class="totales-general">
                <template>
                    <span style="cursor: pointer; text-decoration: underline;"
                          @click="seeInstallations('total_doc', classification, combineInstallationsObjects(data['executed_on_date']['installations'], data['executed_out_of_date']['installations'], data['not_executed_more_3_months']['installations'], data['not_executed_less_3_months']['installations'], data['planned']['installations']))">
                        {{ data['total_doc'] }}
                    </span>
                </template>
            </td>
            <td class="totales-general">
                100%
            </td>
        </template>
    </tr>
</template>

<script>
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"

const {mapFields} = createHelpers({
    getterType: 'dashboardMetrics/getField',
    mutationType: 'dashboardMetrics/updateField',
})

// Mapeo de títulos para las tablas
const TABLE_TITLES = {
    executed_on_date: 'Listado de instalaciones - Ejecutadas en plazo',
    executed_out_of_date: 'Listado de instalaciones - Ejecutadas fuera de plazo',
    planned: 'Listado de instalaciones - Planificada',
    planned_less_3_months: 'Listado de instalaciones - Planificada - menos de dos meses',
    planned_validation: 'Listado de instalaciones - Planificada - pendiente de validación',
    not_executed_less_3_months: 'Listado de instalaciones - Fuera de plazo - menos de 3 meses',
    not_executed_more_3_months: 'Listado de instalaciones - Fuera de plazo - mas de 3 meses',
    total_doc: 'Total'
}

export default {
    name: "CAEView",
    props: ['docname', 'data', 'classification'],
    data() {
        return {
            showLoading: false
        }
    },
    computed: {
        ...mapState('dashboardMetrics', ['dashboard_metrics']),
        ...mapFields({
            dashboard_metrics: 'dashboard_metrics',
            installation_list: 'installation_list',
            tabIndex: 'tabIndex',
            filter: 'filter',
            contentName: 'contentName',
            installations_total: 'installations_total'
        }),
        showPlanned() {
            const currentYear = new Date().getFullYear()
            return this.filter.year >= currentYear
        },
        showOnlyPlanned() {
            const currentYear = new Date().getFullYear()
            return this.filter.year !== (currentYear + 1)
        },
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        /**
         * Combina objetos de instalaciones sin perder duplicados
         * Crea claves únicas cuando hay conflictos
         */
        combineInstallationsObjects(...objects) {
            const combined = {}
            
            objects.forEach(obj => {
                if (!obj || typeof obj !== 'object') return
                
                Object.keys(obj).forEach(key => {
                    if (!combined.hasOwnProperty(key)) {
                        combined[key] = obj[key]
                        return
                    }
                    
                    // Si la clave ya existe, crear una clave única
                    const installations = obj[key]
                    const installationId = this._findInstallationId(installations)
                    const newKey = this._generateUniqueKey(combined, key, installationId)
                    combined[newKey] = obj[key]
                })
            })
            
            return combined
        },
        /**
         * Busca un ID en las instalaciones anidadas
         */
        _findInstallationId(installations) {
            if (!installations || typeof installations !== 'object') {
                return null
            }
            
            for (const instKey in installations) {
                if (installations[instKey]?.id) {
                    return installations[instKey].id
                }
            }
            
            return null
        },
        /**
         * Genera una clave única para evitar conflictos
         */
        _generateUniqueKey(combined, baseKey, installationId) {
            let newKey
            let counter = 1
            
            if (installationId) {
                newKey = `${baseKey}_${installationId}`
                while (combined.hasOwnProperty(newKey)) {
                    newKey = `${baseKey}_${installationId}_${counter}`
                    counter++
                }
            } else {
                newKey = `${baseKey}_${counter}`
                while (combined.hasOwnProperty(newKey)) {
                    counter++
                    newKey = `${baseKey}_${counter}`
                }
            }
            
            return newKey
        },
        /**
         * Extrae los IDs de instalación de la lista anidada
         */
        _extractInstallationIds(installationsList) {
            const installationIds = []
            
            for (const key in installationsList) {
                if (!installationsList.hasOwnProperty(key)) continue
                
                const installations = installationsList[key]
                if (!installations || typeof installations !== 'object') continue
                
                for (const keyInst in installations) {
                    if (installations.hasOwnProperty(keyInst) && installations[keyInst]?.id) {
                        installationIds.push(installations[keyInst].id)
                    }
                }
            }
            
            return installationIds
        },
        /**
         * Procesa la respuesta y combina con los datos de instalaciones originales
         */
        _processInstallationsResponse(response, installationsList, classification) {
            const processedInstallations = []
            
            for (const installationKey in installationsList) {
                if (!installationsList.hasOwnProperty(installationKey)) continue
                
                const installations = installationsList[installationKey]
                if (!installations || typeof installations !== 'object') continue
                
                for (const keyInst in installations) {
                    if (!installations.hasOwnProperty(keyInst)) continue
                    
                    const installation = installations[keyInst]
                    const responseData = response.find(item => item.id === installation.id)
                    
                    if (responseData) {
                        const copiedResponse = {
                            ...responseData,
                            effective_date: installation.effective_date,
                            expected_date: installation.expected_date,
                            classification: classification,
                            document_name: installation.document_name
                        }
                        processedInstallations.push(copiedResponse)
                    }
                }
            }
            
            return processedInstallations
        },
        seeInstallations(content, classification, installationsList = null) {
            if (!installationsList) return
            
            this.tabIndex++
            this.installation_list = []
            this.contentName = this.setTableTitle(content)

            const installationIds = this._extractInstallationIds(installationsList)

            this.$store.dispatch('childrenInstallation/getChildInstallationsByIds', {
                relations: [
                    'typology',
                    'masterInstallation.company',
                    'masterInstallation.responsible',
                    'providerContractEE',
                    'documentOca.inspection'
                ],
                ids: installationIds
            })
            .then(response => {
                this.showLoading = false

                if (response) {
                    this.installation_list = this._processInstallationsResponse(
                        response,
                        installationsList,
                        classification
                    )
                } else {
                    console.error('Error al obtener los datos de las instalaciones:', response)
                }
            })
            .catch(error => {
                this.showLoading = false
                console.error('Error al obtener los datos de las instalaciones:', error)
            })
        },
        setTableTitle(content) {
            return TABLE_TITLES[content] || ''
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';

</style>